export function extractFiscalYearNumber(value) {
  if (value == null) return null;
  const s = String(value).trim();
  if (!s) return null;
  const m = s.match(/\d{4}/);
  if (!m) return null;
  const y = parseInt(m[0], 10);
  return Number.isFinite(y) ? y : null;
}

export function fiscalYearsMatch(a, b) {
  const aStr = String(a ?? "").trim();
  const bStr = String(b ?? "").trim();
  if (!aStr || !bStr) return aStr === bStr;
  const ya = extractFiscalYearNumber(aStr);
  const yb = extractFiscalYearNumber(bStr);
  if (ya != null && yb != null) return ya === yb;
  return aStr.toLowerCase() === bStr.toLowerCase();
}

export function resolveMatchingFiscalYear(candidates, value) {
  const needle = String(value ?? "").trim();
  if (!needle) return needle;
  const match = (candidates || []).find((candidate) =>
    fiscalYearsMatch(candidate, needle)
  );
  return match ? String(match).trim() : needle;
}

export function canonicalizeFiscalYear(value) {
  const trimmed = String(value ?? "").trim();
  if (!trimmed) return "";
  const year = extractFiscalYearNumber(trimmed);
  if (year != null) return `FY${year}`;
  return trimmed;
}
